module.exports = __webpack_public_path__ + "img/line.dd272024.svg";